module.exports = __webpack_public_path__ + "img/digital-m.4eaf3ef7.png";